import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { TROPHY_CONFIG } from '../../../services/utilityFunctions';
import translate from '../../../commonComponents/translate';
import JourneyProp from '../../journey/propTypes/journeyProp';
import WalletCoinsIcon from '../../shared/icons/WalletCoinsIcon';
import CharityCoinsIcon from '../../shared/icons/CharityCoinsIcon';

const detailsLinkText = journey => {
  if (journey.progress === 0) {
    return 'landing_journey_startYour';
  }
  if (journey.progress > 0 && journey.progress < 100) {
    return 'landing_journey_continueYour';
  }
  return 'landing_journey_details';
};

function JourneyItemRewards({ t, journey, isFlipped }) {
  const rewards = journey.rewards || {};
  const coins = rewards.coins || {};
  const trophies = rewards.trophies || {};
  const trophiesToDisplay = Object.entries(trophies)
    .filter(([trophy, value]) => !!value)
    .slice(0, 6)
    .map(([trophy]) => trophy);
  const coupons = (rewards.coupons || []).slice(0, 2);

  const hasRewards =
    coins.wallet > 0 || trophiesToDisplay.length > 0 || coupons.length > 0;

  return (
    <div className="col-lg-4 col-md-4 align-center">
      {hasRewards && (
        <>
          <div
            className={cx({
              'landing-journey-item-yellow-left': isFlipped,
              'landing-journey-item-yellow': !isFlipped,
            })}
          >
            <div className="landing-journey-item-yellow-coins">
              <h3>{t('journey_rewards')}</h3>
              <div className={cx({ 'f-invert': isFlipped })}>
                {!!coins.wallet && (
                  <>
                    <WalletCoinsIcon />
                    <p>
                      {coins.wallet || 0}
                      <span>{t('rewards_coins')}</span>
                    </p>
                  </>
                )}
                {!!coins.charity && (
                  <>
                    <CharityCoinsIcon />
                    <p>
                      {coins.charity || 0}
                      <span>{t('rewards_coins')}</span>
                    </p>
                  </>
                )}
              </div>
            </div>
            {trophiesToDisplay.length > 0 && (
              <div
                className={cx('landing-journey-item-yellow-trophies', {
                  'f-invert': isFlipped,
                })}
              >
                <h3>{t('journey_trophies')}</h3>
                <div className="landing-journey-item-yellow-trophies-img">
                  {trophiesToDisplay.map(trophy => (
                    <img
                      key={trophy}
                      alt="trophy"
                      src={TROPHY_CONFIG[trophy].imageURL}
                    />
                  ))}
                </div>
              </div>
            )}
            {coupons.length > 0 && (
              <div className="landing-journey-item-yellow-coupons">
                <h3>{t('journey_coupons')}</h3>
                <div
                  className={cx({
                    'landing-journey-item-yellow-coupons-container': true,
                    'f-invert': isFlipped,
                  })}
                >
                  {coupons.map(coupon => (
                    <div
                      key={coupon.name + coupon.expirationDate}
                      className="landing-journey-item-yellow-coupons-item"
                    >
                      <img
                        src={
                          coupon.image
                            ? coupon.image.thumb
                            : '/images/no_image_upload.png'
                        }
                        alt="coupon"
                      />
                      <p>{coupon.name}</p>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
          <br />
        </>
      )}
      <a
        href={`/journey/${journey.slug}`}
        className="landing-certification-browse btn m-btn--pill btn-dynamic"
      >
        {t(detailsLinkText(journey))}
      </a>
    </div>
  );
}

JourneyItemRewards.propTypes = {
  t: PropTypes.func.isRequired,
  journey: PropTypes.shape(JourneyProp.propType).isRequired,
  isFlipped: PropTypes.bool,
};

JourneyItemRewards.defaultProps = {
  isFlipped: false,
};

export default translate(JourneyItemRewards);
